var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar",style:({ height: (_vm.customHeight + "rem") })},[_c('div',{class:['progress-bar__value', {'progress-bar__value--dark' : _vm.dark}],style:({
            width: (_vm.computedPercentageForWidth + "%"),
            backgroundColor: _vm.progressBarColor,
        })}),(_vm.showNumber)?_c('span',{staticClass:"progress-bar__text"},[_vm._v(" "+_vm._s(_vm.percentageText)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }